import React, { useContext, useCallback, useEffect, useState } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Swal from 'sweetalert2'
const config = require('../config.json')

export default function Forgot({ ipAddress, onLogin }) {
    const [lid, setlid] = useState('')
    const [pass, setpass] = useState('')
    // const history = useContext(HistoryContext)
    const history = useHistory();
    
    const handleLogin = async (event) => {
        event.preventDefault()
        try {
            login();
        } catch (err) {
            
        }
    }

    const login = async () => {

        let ip = ipAddress
        let data = JSON.stringify({
            "lid": lid,
            "email": pass,
            "ip": ip
        });
        let axiosConfig = {
            method: 'post',
            url: `${config.baseUrl}/api/forgot`,
            headers: {
                'ulid': lid,
                'ip': ip,
                'Content-Type': 'application/json'
            },
            data: data
        };
        console.log(axiosConfig)
        let response = await axios.request(axiosConfig)
        console.log(response)
        response = response.data
        if (response.status) {
            // console.log(response,data)
            Swal.fire({
                icon: 'info',
                title: 'LinkDao Defi',
                text: response?.message
            })
            
        }
        else if (response.code === 30) {
            Swal.fire({
                icon: 'info',
                title: 'LinkDao Defi',
                text: response?.message
            }).then(() => {
                history.push('/register');
            })
        }
    };
    
    return (
        <div className="container-xxl">
            <div className="authentication-wrapper authentication-basic container-p-y">
                <div className="authentication-inner py-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="app-brand justify-content-center">
                                <Link to="/" className="app-brand-link gap-2">
                                    <span className="app-brand-logo demo">
                                        <img src="assets/ficon.svg" style={{ height: '40px', width: 'auto' }} alt='ficon' />
                                    </span>
                                    <span className="app-brand-text demo text-body fw-bolder" style={{ textTransform: "initial" }}>Link<span className='text-info'>Dao</span> </span>
                                </Link>
                            </div>
                            <h4 className="mb-2 text-info">Forgot Password</h4>
                            <form id="formAuthentication" className="mb-3" onSubmit={handleLogin}>
                            <div className="mb-3">
                                    <label htmlFor="1email" className="form-label">User ID</label>
                                    <input type="text" className="form-control" id="lid" name="lid" placeholder="Enter User ID" value={lid} onChange={(e) => setlid(e.target.value)} />
                                </div>
                                 <div className="mb-3">
                                    <label htmlFor="e1mail" className="form-label">Register Email</label>
                                    <input type="email" className="form-control" id="pass" name="pass" placeholder="Enter your register Email" value={pass} onChange={(e) => setpass(e.target.value)} />
                                </div>
                                <button className="btn btn-info d-grid w-100" >Get Password</button>
                            </form>
                            <div className="text-center d-flex justify-content-center">
                                <Link to="/" className="d-flex align-items-center justify-content-center text-info m-2"> Login </Link>
                                <Link to="/register" className="d-flex align-items-center justify-content-center text-warning m-2"> Forgot Password </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
